export default __webpack_public_path__ + "static/media/aviaoAureaVertical.73d67929.png";